/**
 * Feature flags configuration
 * These can be controlled via environment variables or hardcoded for specific builds
 */

interface FeatureFlags {
  STORE_ENABLED: boolean
  MOBILE_MENU_ENHANCED: boolean
  ABOUT_PAGE_ENABLED: boolean
  SERVICES_PAGE_ENABLED: boolean
}

type FeatureFlagEnv = Record<string, string | undefined>

const getFeatureFlag = (
  key: keyof FeatureFlags,
  defaultValue: boolean
): boolean => {
  const envKey = `VITE_FEATURE_${key}`
  const env = (import.meta as ImportMeta & { env?: FeatureFlagEnv }).env ?? {}
  const envValue = env[envKey]

  if (typeof envValue === 'string') {
    return envValue === 'true'
  }

  return defaultValue
}

export const featureFlags: FeatureFlags = {
  STORE_ENABLED: getFeatureFlag('STORE_ENABLED', false), // Default: disabled - redirects to home
  MOBILE_MENU_ENHANCED: getFeatureFlag('MOBILE_MENU_ENHANCED', true),
  ABOUT_PAGE_ENABLED: getFeatureFlag('ABOUT_PAGE_ENABLED', true), // Default: enabled
  SERVICES_PAGE_ENABLED: getFeatureFlag('SERVICES_PAGE_ENABLED', true), // Default: enabled
}

export const isFeatureEnabled = (flag: keyof FeatureFlags): boolean => {
  return featureFlags[flag]
}
